import React, { useContext } from 'react';
import style from './style';
import commonStyle from '../style';
import {FormGroup, FormLabel, Grid, TextField, Typography} from "@mui/material";
import clsx from "clsx";
import i18next from "i18next";
import {Controller, useFormContext} from "react-hook-form";
import EAColorIcon from "../../../../../components/common/EAColorIcon";
import { isContextModelNameAvailable } from '../../../../../services/edge/ContexteService';
import { Context } from '../../../../../states/Store';

const Informations = ({context, readOnly = false}) => {
  const {classes} = style();
  const {classes: commonClasses} = commonStyle();
  const [state, dispatch] = useContext(Context);

  const {
    control, formState: {errors},
  } = useFormContext();

  return <div className={classes.root} id={'informations'}>
    <Typography variant={'h3'} className={commonClasses.partTitle}>
      <EAColorIcon icon={'/context/contextModel/informationPart'} svgStyle={{marginRight: '5px', position: "relative", top: "3px"}} />
      {`${i18next.t("demandes.contextModel.ficheModel.modifierModel")}`}
    </Typography>
    <Grid container spacing={2} className={clsx(classes.inputContainer,commonClasses.part)}>
      <Grid item xs={8}>
        <div className={clsx(classes.inputWrapper, classes.item)}>
          <FormLabel className={classes.formLabel}>
            {`${i18next.t("demandes.contextModel.creationForm.config.label")} * `}
          </FormLabel>
          <FormGroup>
            <Controller
              control={control}
              name="name"
              rules={{
                required: i18next.t("infos.required"), validate: async (value) => {
                  if(value === context.name) return true;
                  if (value.length > 100) {
                    return i18next.t("demandes.contextModel.creationForm.config.labelLengthError")
                  }
                  const isNameAvailable = await isContextModelNameAvailable(state.account.id, value, dispatch);
                  if(!isNameAvailable) {
                    return i18next.t("demandes.contextModel.creationForm.config.nameError")
                  }
                  return true;
                },
              }}
              render={({field}) => (<TextField
                  id="name"
                  className={clsx(classes.textField)}
                  placeholder={i18next.t("demandes.contextModel.creationForm.config.placeholder.modelLabel")}
                  variant="outlined"
                  error={!!errors.name}
                  helperText={errors.name?.message}
                  fullWidth
                  disabled={readOnly}
                  {...field}
                />)}
            />

          </FormGroup>
        </div>
      </Grid>
      <Grid item xs={4}>
        <div className={clsx(classes.inputWrapper, classes.item)}>
          <FormLabel className={classes.formLabel}>
            {`${i18next.t("demandes.contextModel.creationForm.config.code")} * `}
          </FormLabel>
          <FormGroup>
            <Controller
              control={control}
              name="code"
              rules={{
                required: i18next.t("infos.required"), validate: (value) => {
                  if (value.length > 100) {
                    return i18next.t("demandes.contextModel.creationForm.config.labelLengthError")
                  }
                  return true;
                },
              }}
              render={({field}) => (<TextField
                  id="code"
                  className={clsx(classes.textField)}
                  placeholder={i18next.t("demandes.contextModel.creationForm.config.placeholder.code")}
                  variant="outlined"
                  error={!!errors.code}
                  helperText={errors.code?.message}
                  fullWidth
                  disabled={readOnly}
                  {...field}
                />)}
            />

          </FormGroup>
        </div>
      </Grid>
      <Grid item xs={12}>

        <div className={clsx(classes.textInputWrapper, classes.item)}>
          <FormLabel className={classes.formLabel}>
            {`${i18next.t("demandes.contextModel.creationForm.config.description")}`}
          </FormLabel>
          <FormGroup>
            <Controller
              control={control}
              name="description"
              rules={{
                validate: (value) => {
                  if (value && value.length > 1000) {
                    return i18next.t("demandes.contextModel.creationForm.config.descriptionLengthError")
                  }
                  return true;
                },
              }}
              render={({field}) => (<TextField
                  id="description"
                  multiline
                  rows={4}
                  className={clsx(classes.textField)}
                  placeholder={i18next.t("demandes.contextModel.creationForm.config.placeholder.modelDescription")}
                  variant="outlined"
                  error={!!errors.libelle}
                  fullWidth
                  helperText={!!errors.libelle ? errors.libelle.message : ""}
                  disabled={readOnly}
                  {...field}
                />)}
            />
            <p
              className={classes.inputHelper}>{i18next.t("demandes.contextModel.creationForm.config.descriptionHelp")}</p>
          </FormGroup>

        </div>
      </Grid>
    </Grid>
  </div>
}

export default Informations;